import { Helmet } from 'react-helmet-async'

export function PostDetailsHelmet({ post }) {
  if (!post) return null

  const title = post.title || 'כתבה חדשה - AniZone'

  const description =
    post.description ||
    (post.content
      ? post.content.replace(/<[^>]+>/g, '').trim().slice(0, 160) + '...'
      : 'כתבה חדשה באתר AniZone – קראו המלצות, חדשות, ודירוגים מהעולם היפני.')

  const image =
    post.imageUrl || 'https://www.anizone.co.il/assets/default-article.jpg'

  const postId =
    typeof post._id === 'object' && post._id.$oid ? post._id.$oid : post._id

  const url = `https://www.anizone.co.il/post/${postId}`

  const publishedTime = post.createdAt
    ? new Date(post.createdAt).toISOString()
    : new Date().toISOString()

  const modifiedTime = post.updatedAt
    ? new Date(post.updatedAt).toISOString()
    : publishedTime

  const keywords = `אנימה, מנגה, ${title}, ${post.tags?.join(', ') || ''}, כתבות AniZone`

  const wordCount = post.content
    ? post.content.replace(/<[^>]+>/g, '').trim().split(/\s+/).length
    : 0

  const commentCount = typeof post.commentCount === 'number' ? post.commentCount : undefined

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
    headline: title,
    description,
    image: {
      '@type': 'ImageObject',
      url: image,
    },
    author: {
      '@type': 'Person',
      name: 'AniZone Team',
    },
    publisher: {
      '@type': 'Organization',
      name: 'AniZone',
      logo: {
        '@type': 'ImageObject',
        url: 'https://pub-60946b28fb374ff48942bac3163dd658.r2.dev/uploads/2025/05/logo-1747045147075.webp',
      },
    },
    datePublished: publishedTime,
    dateModified: modifiedTime,
    articleSection: post.tags?.[0] || 'כתבות',
    keywords,
    wordCount,
    isAccessibleForFree: true,
  }

  if (commentCount !== undefined) {
    schemaData.commentCount = commentCount
  }

  return (
    <Helmet>
      <title>{`${title} - AniZone`}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="article" />
      <meta property="og:title" content={`${title} - AniZone`} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={`תמונה עבור ${title}`} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="AniZone" />
      <meta property="article:author" content="AniZone Team" />
      <meta property="article:published_time" content={publishedTime} />
      <meta property="article:modified_time" content={modifiedTime} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`${title} - AniZone`} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:url" content={url} />

      {/* JSON-LD Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(schemaData),
        }}
      />
    </Helmet>
  )
}
